// @generated by protoc-gen-es v2.11.0 with parameter "ts_nocheck=true,target=ts"
// @generated from file record.proto (package Records, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file record.proto.
 */
export const file_record: GenFile =
  /*@__PURE__*/
  fileDesc(
    "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",
  );

/**
 * @generated from message Records.RecordType
 */
export type RecordType = Message<"Records.RecordType"> & {
  /**
   * @generated from field: int32 recordTypeId = 1;
   */
  recordTypeId: number;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * @generated from field: Records.RecordTypeScope scope = 3;
   */
  scope: RecordTypeScope;
};

/**
 * Describes the message Records.RecordType.
 * Use `create(RecordTypeSchema)` to create a new message.
 */
export const RecordTypeSchema: GenMessage<RecordType> = /*@__PURE__*/ messageDesc(file_record, 0);

/**
 * @generated from message Records.RecordTypesRequest
 */
export type RecordTypesRequest = Message<"Records.RecordTypesRequest"> & {
  /**
   * @generated from field: bool standard = 1;
   */
  standard: boolean;

  /**
   * @generated from field: bool user = 2;
   */
  user: boolean;

  /**
   * @generated from field: bool enterprise = 3;
   */
  enterprise: boolean;

  /**
   * @generated from field: bool pam = 4;
   */
  pam: boolean;
};

/**
 * Describes the message Records.RecordTypesRequest.
 * Use `create(RecordTypesRequestSchema)` to create a new message.
 */
export const RecordTypesRequestSchema: GenMessage<RecordTypesRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 1);

/**
 * @generated from message Records.RecordTypesResponse
 */
export type RecordTypesResponse = Message<"Records.RecordTypesResponse"> & {
  /**
   * @generated from field: repeated Records.RecordType recordTypes = 1;
   */
  recordTypes: RecordType[];

  /**
   * @generated from field: int32 standardCounter = 2;
   */
  standardCounter: number;

  /**
   * @generated from field: int32 userCounter = 3;
   */
  userCounter: number;

  /**
   * @generated from field: int32 enterpriseCounter = 4;
   */
  enterpriseCounter: number;

  /**
   * @generated from field: int32 pamCounter = 5;
   */
  pamCounter: number;
};

/**
 * Describes the message Records.RecordTypesResponse.
 * Use `create(RecordTypesResponseSchema)` to create a new message.
 */
export const RecordTypesResponseSchema: GenMessage<RecordTypesResponse> =
  /*@__PURE__*/
  messageDesc(file_record, 2);

/**
 * @generated from message Records.RecordTypeModifyResponse
 */
export type RecordTypeModifyResponse = Message<"Records.RecordTypeModifyResponse"> & {
  /**
   * @generated from field: int32 recordTypeId = 1;
   */
  recordTypeId: number;

  /**
   * @generated from field: int32 counter = 2;
   */
  counter: number;
};

/**
 * Describes the message Records.RecordTypeModifyResponse.
 * Use `create(RecordTypeModifyResponseSchema)` to create a new message.
 */
export const RecordTypeModifyResponseSchema: GenMessage<RecordTypeModifyResponse> =
  /*@__PURE__*/
  messageDesc(file_record, 3);

/**
 * @generated from message Records.RecordsGetRequest
 */
export type RecordsGetRequest = Message<"Records.RecordsGetRequest"> & {
  /**
   * @generated from field: repeated bytes record_uids = 1;
   */
  recordUids: Uint8Array[];

  /**
   * @generated from field: int64 client_time = 2;
   */
  clientTime: bigint;
};

/**
 * Describes the message Records.RecordsGetRequest.
 * Use `create(RecordsGetRequestSchema)` to create a new message.
 */
export const RecordsGetRequestSchema: GenMessage<RecordsGetRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 4);

/**
 * @generated from message Records.Record
 */
export type Record = Message<"Records.Record"> & {
  /**
   * @generated from field: bytes record_uid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes record_key = 2;
   */
  recordKey: Uint8Array;

  /**
   * @generated from field: Records.RecordKeyType record_key_type = 3;
   */
  recordKeyType: RecordKeyType;

  /**
   * @generated from field: bytes data = 4;
   */
  data: Uint8Array;

  /**
   * @generated from field: bytes extra = 5;
   */
  extra: Uint8Array;

  /**
   * @generated from field: int32 version = 6;
   */
  version: number;

  /**
   * @generated from field: int64 client_modified_time = 7;
   */
  clientModifiedTime: bigint;

  /**
   * @generated from field: int64 revision = 8;
   */
  revision: bigint;

  /**
   * @generated from field: repeated bytes file_ids = 9;
   */
  fileIds: Uint8Array[];
};

/**
 * Describes the message Records.Record.
 * Use `create(RecordSchema)` to create a new message.
 */
export const RecordSchema: GenMessage<Record> = /*@__PURE__*/ messageDesc(file_record, 5);

/**
 * @generated from message Records.FolderRecordKey
 */
export type FolderRecordKey = Message<"Records.FolderRecordKey"> & {
  /**
   * @generated from field: bytes folder_uid = 1;
   */
  folderUid: Uint8Array;

  /**
   * @generated from field: bytes record_uid = 2;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes record_key = 3;
   */
  recordKey: Uint8Array;
};

/**
 * Describes the message Records.FolderRecordKey.
 * Use `create(FolderRecordKeySchema)` to create a new message.
 */
export const FolderRecordKeySchema: GenMessage<FolderRecordKey> =
  /*@__PURE__*/
  messageDesc(file_record, 6);

/**
 * @generated from message Records.Folder
 */
export type Folder = Message<"Records.Folder"> & {
  /**
   * @generated from field: bytes folder_uid = 1;
   */
  folderUid: Uint8Array;

  /**
   * @generated from field: bytes folder_key = 2;
   */
  folderKey: Uint8Array;

  /**
   * @generated from field: Records.RecordKeyType folder_key_type = 3;
   */
  folderKeyType: RecordKeyType;
};

/**
 * Describes the message Records.Folder.
 * Use `create(FolderSchema)` to create a new message.
 */
export const FolderSchema: GenMessage<Folder> = /*@__PURE__*/ messageDesc(file_record, 7);

/**
 * @generated from message Records.Team
 */
export type Team = Message<"Records.Team"> & {
  /**
   * @generated from field: bytes team_uid = 1;
   */
  teamUid: Uint8Array;

  /**
   * @generated from field: bytes team_key = 2;
   */
  teamKey: Uint8Array;

  /**
   * @generated from field: bytes team_private_key = 3;
   */
  teamPrivateKey: Uint8Array;

  /**
   * @generated from field: Records.RecordKeyType team_key_type = 4;
   */
  teamKeyType: RecordKeyType;

  /**
   * @generated from field: repeated Records.Folder folders = 5;
   */
  folders: Folder[];
};

/**
 * Describes the message Records.Team.
 * Use `create(TeamSchema)` to create a new message.
 */
export const TeamSchema: GenMessage<Team> = /*@__PURE__*/ messageDesc(file_record, 8);

/**
 * @generated from message Records.RecordsGetResponse
 */
export type RecordsGetResponse = Message<"Records.RecordsGetResponse"> & {
  /**
   * @generated from field: repeated Records.Record records = 1;
   */
  records: Record[];

  /**
   * @generated from field: repeated Records.FolderRecordKey folder_record_keys = 2;
   */
  folderRecordKeys: FolderRecordKey[];

  /**
   * @generated from field: repeated Records.Folder folders = 3;
   */
  folders: Folder[];

  /**
   * @generated from field: repeated Records.Team teams = 4;
   */
  teams: Team[];
};

/**
 * Describes the message Records.RecordsGetResponse.
 * Use `create(RecordsGetResponseSchema)` to create a new message.
 */
export const RecordsGetResponseSchema: GenMessage<RecordsGetResponse> =
  /*@__PURE__*/
  messageDesc(file_record, 9);

/**
 * @generated from message Records.RecordLink
 */
export type RecordLink = Message<"Records.RecordLink"> & {
  /**
   * @generated from field: bytes record_uid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes record_key = 2;
   */
  recordKey: Uint8Array;
};

/**
 * Describes the message Records.RecordLink.
 * Use `create(RecordLinkSchema)` to create a new message.
 */
export const RecordLinkSchema: GenMessage<RecordLink> = /*@__PURE__*/ messageDesc(file_record, 10);

/**
 * @generated from message Records.RecordAudit
 */
export type RecordAudit = Message<"Records.RecordAudit"> & {
  /**
   * @generated from field: int32 version = 1;
   */
  version: number;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;
};

/**
 * Describes the message Records.RecordAudit.
 * Use `create(RecordAuditSchema)` to create a new message.
 */
export const RecordAuditSchema: GenMessage<RecordAudit> =
  /*@__PURE__*/
  messageDesc(file_record, 11);

/**
 * @generated from message Records.SecurityData
 */
export type SecurityData = Message<"Records.SecurityData"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;
};

/**
 * Describes the message Records.SecurityData.
 * Use `create(SecurityDataSchema)` to create a new message.
 */
export const SecurityDataSchema: GenMessage<SecurityData> =
  /*@__PURE__*/
  messageDesc(file_record, 12);

/**
 * @generated from message Records.SecurityScoreData
 */
export type SecurityScoreData = Message<"Records.SecurityScoreData"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;
};

/**
 * Describes the message Records.SecurityScoreData.
 * Use `create(SecurityScoreDataSchema)` to create a new message.
 */
export const SecurityScoreDataSchema: GenMessage<SecurityScoreData> =
  /*@__PURE__*/
  messageDesc(file_record, 13);

/**
 * @generated from message Records.RecordAdd
 */
export type RecordAdd = Message<"Records.RecordAdd"> & {
  /**
   * @generated from field: bytes record_uid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes record_key = 2;
   */
  recordKey: Uint8Array;

  /**
   * @generated from field: int64 client_modified_time = 3;
   */
  clientModifiedTime: bigint;

  /**
   * @generated from field: bytes data = 4;
   */
  data: Uint8Array;

  /**
   * @generated from field: bytes non_shared_data = 5;
   */
  nonSharedData: Uint8Array;

  /**
   * @generated from field: Records.RecordFolderType folder_type = 6;
   */
  folderType: RecordFolderType;

  /**
   * @generated from field: bytes folder_uid = 7;
   */
  folderUid: Uint8Array;

  /**
   * @generated from field: bytes folder_key = 8;
   */
  folderKey: Uint8Array;

  /**
   * @generated from field: repeated Records.RecordLink record_links = 9;
   */
  recordLinks: RecordLink[];

  /**
   * @generated from field: Records.RecordAudit audit = 10;
   */
  audit?: RecordAudit;

  /**
   * @generated from field: Records.SecurityData securityData = 11;
   */
  securityData?: SecurityData;

  /**
   * @generated from field: Records.SecurityScoreData securityScoreData = 12;
   */
  securityScoreData?: SecurityScoreData;
};

/**
 * Describes the message Records.RecordAdd.
 * Use `create(RecordAddSchema)` to create a new message.
 */
export const RecordAddSchema: GenMessage<RecordAdd> = /*@__PURE__*/ messageDesc(file_record, 14);

/**
 * @generated from message Records.RecordsAddRequest
 */
export type RecordsAddRequest = Message<"Records.RecordsAddRequest"> & {
  /**
   * @generated from field: repeated Records.RecordAdd records = 1;
   */
  records: RecordAdd[];

  /**
   * @generated from field: int64 client_time = 2;
   */
  clientTime: bigint;

  /**
   * @generated from field: Records.RecordKeyType security_data_key_type = 3;
   */
  securityDataKeyType: RecordKeyType;
};

/**
 * Describes the message Records.RecordsAddRequest.
 * Use `create(RecordsAddRequestSchema)` to create a new message.
 */
export const RecordsAddRequestSchema: GenMessage<RecordsAddRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 15);

/**
 * @generated from message Records.RecordUpdate
 */
export type RecordUpdate = Message<"Records.RecordUpdate"> & {
  /**
   * @generated from field: bytes record_uid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: int64 client_modified_time = 2;
   */
  clientModifiedTime: bigint;

  /**
   * @generated from field: int64 revision = 3;
   */
  revision: bigint;

  /**
   * @generated from field: bytes data = 4;
   */
  data: Uint8Array;

  /**
   * @generated from field: bytes non_shared_data = 5;
   */
  nonSharedData: Uint8Array;

  /**
   * @generated from field: repeated Records.RecordLink record_links_add = 6;
   */
  recordLinksAdd: RecordLink[];

  /**
   * @generated from field: repeated bytes record_links_remove = 7;
   */
  recordLinksRemove: Uint8Array[];

  /**
   * @generated from field: Records.RecordAudit audit = 8;
   */
  audit?: RecordAudit;

  /**
   * @generated from field: Records.SecurityData securityData = 9;
   */
  securityData?: SecurityData;

  /**
   * @generated from field: Records.SecurityScoreData securityScoreData = 10;
   */
  securityScoreData?: SecurityScoreData;
};

/**
 * Describes the message Records.RecordUpdate.
 * Use `create(RecordUpdateSchema)` to create a new message.
 */
export const RecordUpdateSchema: GenMessage<RecordUpdate> =
  /*@__PURE__*/
  messageDesc(file_record, 16);

/**
 * @generated from message Records.RecordsUpdateRequest
 */
export type RecordsUpdateRequest = Message<"Records.RecordsUpdateRequest"> & {
  /**
   * @generated from field: repeated Records.RecordUpdate records = 1;
   */
  records: RecordUpdate[];

  /**
   * @generated from field: int64 client_time = 2;
   */
  clientTime: bigint;

  /**
   * @generated from field: Records.RecordKeyType security_data_key_type = 3;
   */
  securityDataKeyType: RecordKeyType;
};

/**
 * Describes the message Records.RecordsUpdateRequest.
 * Use `create(RecordsUpdateRequestSchema)` to create a new message.
 */
export const RecordsUpdateRequestSchema: GenMessage<RecordsUpdateRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 17);

/**
 * @generated from message Records.RecordFileForConversion
 */
export type RecordFileForConversion = Message<"Records.RecordFileForConversion"> & {
  /**
   * @generated from field: bytes record_uid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: string file_file_id = 2;
   */
  fileFileId: string;

  /**
   * @generated from field: string thumb_file_id = 3;
   */
  thumbFileId: string;

  /**
   * @generated from field: bytes data = 4;
   */
  data: Uint8Array;

  /**
   * @generated from field: bytes record_key = 5;
   */
  recordKey: Uint8Array;

  /**
   * @generated from field: bytes link_key = 6;
   */
  linkKey: Uint8Array;
};

/**
 * Describes the message Records.RecordFileForConversion.
 * Use `create(RecordFileForConversionSchema)` to create a new message.
 */
export const RecordFileForConversionSchema: GenMessage<RecordFileForConversion> =
  /*@__PURE__*/
  messageDesc(file_record, 18);

/**
 * @generated from message Records.RecordFolderForConversion
 */
export type RecordFolderForConversion = Message<"Records.RecordFolderForConversion"> & {
  /**
   * @generated from field: bytes folder_uid = 1;
   */
  folderUid: Uint8Array;

  /**
   * @generated from field: bytes record_folder_key = 2;
   */
  recordFolderKey: Uint8Array;
};

/**
 * Describes the message Records.RecordFolderForConversion.
 * Use `create(RecordFolderForConversionSchema)` to create a new message.
 */
export const RecordFolderForConversionSchema: GenMessage<RecordFolderForConversion> =
  /*@__PURE__*/
  messageDesc(file_record, 19);

/**
 * @generated from message Records.RecordConvertToV3
 */
export type RecordConvertToV3 = Message<"Records.RecordConvertToV3"> & {
  /**
   * @generated from field: bytes record_uid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: int64 client_modified_time = 2;
   */
  clientModifiedTime: bigint;

  /**
   * @generated from field: int64 revision = 3;
   */
  revision: bigint;

  /**
   * @generated from field: bytes data = 4;
   */
  data: Uint8Array;

  /**
   * @generated from field: bytes non_shared_data = 5;
   */
  nonSharedData: Uint8Array;

  /**
   * @generated from field: Records.RecordAudit audit = 6;
   */
  audit?: RecordAudit;

  /**
   * @generated from field: repeated Records.RecordFileForConversion record_file = 7;
   */
  recordFile: RecordFileForConversion[];

  /**
   * @generated from field: repeated Records.RecordFolderForConversion folder_key = 8;
   */
  folderKey: RecordFolderForConversion[];
};

/**
 * Describes the message Records.RecordConvertToV3.
 * Use `create(RecordConvertToV3Schema)` to create a new message.
 */
export const RecordConvertToV3Schema: GenMessage<RecordConvertToV3> =
  /*@__PURE__*/
  messageDesc(file_record, 20);

/**
 * @generated from message Records.RecordsConvertToV3Request
 */
export type RecordsConvertToV3Request = Message<"Records.RecordsConvertToV3Request"> & {
  /**
   * @generated from field: repeated Records.RecordConvertToV3 records = 1;
   */
  records: RecordConvertToV3[];

  /**
   * @generated from field: int64 client_time = 2;
   */
  clientTime: bigint;
};

/**
 * Describes the message Records.RecordsConvertToV3Request.
 * Use `create(RecordsConvertToV3RequestSchema)` to create a new message.
 */
export const RecordsConvertToV3RequestSchema: GenMessage<RecordsConvertToV3Request> =
  /*@__PURE__*/
  messageDesc(file_record, 21);

/**
 * @generated from message Records.RecordsRemoveRequest
 */
export type RecordsRemoveRequest = Message<"Records.RecordsRemoveRequest"> & {
  /**
   * @generated from field: repeated bytes records = 1;
   */
  records: Uint8Array[];
};

/**
 * Describes the message Records.RecordsRemoveRequest.
 * Use `create(RecordsRemoveRequestSchema)` to create a new message.
 */
export const RecordsRemoveRequestSchema: GenMessage<RecordsRemoveRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 22);

/**
 * @generated from message Records.RecordRevert
 */
export type RecordRevert = Message<"Records.RecordRevert"> & {
  /**
   * @generated from field: bytes record_uid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: int64 revert_to_revision = 2;
   */
  revertToRevision: bigint;
};

/**
 * Describes the message Records.RecordRevert.
 * Use `create(RecordRevertSchema)` to create a new message.
 */
export const RecordRevertSchema: GenMessage<RecordRevert> =
  /*@__PURE__*/
  messageDesc(file_record, 23);

/**
 * @generated from message Records.RecordsRevertRequest
 */
export type RecordsRevertRequest = Message<"Records.RecordsRevertRequest"> & {
  /**
   * @generated from field: repeated Records.RecordRevert records = 1;
   */
  records: RecordRevert[];
};

/**
 * Describes the message Records.RecordsRevertRequest.
 * Use `create(RecordsRevertRequestSchema)` to create a new message.
 */
export const RecordsRevertRequestSchema: GenMessage<RecordsRevertRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 24);

/**
 * @generated from message Records.RecordLinkError
 */
export type RecordLinkError = Message<"Records.RecordLinkError"> & {
  /**
   * @generated from field: bytes record_uid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: Records.RecordModifyResult status = 2;
   */
  status: RecordModifyResult;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message Records.RecordLinkError.
 * Use `create(RecordLinkErrorSchema)` to create a new message.
 */
export const RecordLinkErrorSchema: GenMessage<RecordLinkError> =
  /*@__PURE__*/
  messageDesc(file_record, 25);

/**
 * @generated from message Records.RecordModifyStatus
 */
export type RecordModifyStatus = Message<"Records.RecordModifyStatus"> & {
  /**
   * @generated from field: bytes record_uid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: Records.RecordModifyResult status = 2;
   */
  status: RecordModifyResult;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: repeated Records.RecordLinkError link_errors = 4;
   */
  linkErrors: RecordLinkError[];
};

/**
 * Describes the message Records.RecordModifyStatus.
 * Use `create(RecordModifyStatusSchema)` to create a new message.
 */
export const RecordModifyStatusSchema: GenMessage<RecordModifyStatus> =
  /*@__PURE__*/
  messageDesc(file_record, 26);

/**
 * @generated from message Records.RecordsModifyResponse
 */
export type RecordsModifyResponse = Message<"Records.RecordsModifyResponse"> & {
  /**
   * @generated from field: repeated Records.RecordModifyStatus records = 1;
   */
  records: RecordModifyStatus[];

  /**
   * @generated from field: int64 revision = 2;
   */
  revision: bigint;
};

/**
 * Describes the message Records.RecordsModifyResponse.
 * Use `create(RecordsModifyResponseSchema)` to create a new message.
 */
export const RecordsModifyResponseSchema: GenMessage<RecordsModifyResponse> =
  /*@__PURE__*/
  messageDesc(file_record, 27);

/**
 * @generated from message Records.RecordAddAuditData
 */
export type RecordAddAuditData = Message<"Records.RecordAddAuditData"> & {
  /**
   * @generated from field: bytes record_uid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: int64 revision = 2;
   */
  revision: bigint;

  /**
   * @generated from field: bytes data = 3;
   */
  data: Uint8Array;

  /**
   * @generated from field: int32 version = 4;
   */
  version: number;
};

/**
 * Describes the message Records.RecordAddAuditData.
 * Use `create(RecordAddAuditDataSchema)` to create a new message.
 */
export const RecordAddAuditDataSchema: GenMessage<RecordAddAuditData> =
  /*@__PURE__*/
  messageDesc(file_record, 28);

/**
 * @generated from message Records.AddAuditDataRequest
 */
export type AddAuditDataRequest = Message<"Records.AddAuditDataRequest"> & {
  /**
   * @generated from field: repeated Records.RecordAddAuditData records = 1;
   */
  records: RecordAddAuditData[];
};

/**
 * Describes the message Records.AddAuditDataRequest.
 * Use `create(AddAuditDataRequestSchema)` to create a new message.
 */
export const AddAuditDataRequestSchema: GenMessage<AddAuditDataRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 29);

/**
 * @generated from message Records.File
 */
export type File = Message<"Records.File"> & {
  /**
   * @generated from field: bytes record_uid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes record_key = 2;
   */
  recordKey: Uint8Array;

  /**
   * @generated from field: bytes data = 3;
   */
  data: Uint8Array;

  /**
   * @generated from field: int64 fileSize = 4;
   */
  fileSize: bigint;

  /**
   * @generated from field: int32 thumbSize = 5;
   */
  thumbSize: number;

  /**
   * @generated from field: bool is_script = 6;
   */
  isScript: boolean;
};

/**
 * Describes the message Records.File.
 * Use `create(FileSchema)` to create a new message.
 */
export const FileSchema: GenMessage<File> = /*@__PURE__*/ messageDesc(file_record, 30);

/**
 * @generated from message Records.FilesAddRequest
 */
export type FilesAddRequest = Message<"Records.FilesAddRequest"> & {
  /**
   * @generated from field: repeated Records.File files = 1;
   */
  files: File[];

  /**
   * @generated from field: int64 client_time = 2;
   */
  clientTime: bigint;
};

/**
 * Describes the message Records.FilesAddRequest.
 * Use `create(FilesAddRequestSchema)` to create a new message.
 */
export const FilesAddRequestSchema: GenMessage<FilesAddRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 31);

/**
 * @generated from message Records.FileAddStatus
 */
export type FileAddStatus = Message<"Records.FileAddStatus"> & {
  /**
   * @generated from field: bytes record_uid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: Records.FileAddResult status = 2;
   */
  status: FileAddResult;

  /**
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * @generated from field: string parameters = 4;
   */
  parameters: string;

  /**
   * @generated from field: string thumbnail_parameters = 5;
   */
  thumbnailParameters: string;

  /**
   * @generated from field: int32 success_status_code = 6;
   */
  successStatusCode: number;
};

/**
 * Describes the message Records.FileAddStatus.
 * Use `create(FileAddStatusSchema)` to create a new message.
 */
export const FileAddStatusSchema: GenMessage<FileAddStatus> =
  /*@__PURE__*/
  messageDesc(file_record, 32);

/**
 * @generated from message Records.FilesAddResponse
 */
export type FilesAddResponse = Message<"Records.FilesAddResponse"> & {
  /**
   * @generated from field: repeated Records.FileAddStatus files = 1;
   */
  files: FileAddStatus[];

  /**
   * @generated from field: int64 revision = 2;
   */
  revision: bigint;
};

/**
 * Describes the message Records.FilesAddResponse.
 * Use `create(FilesAddResponseSchema)` to create a new message.
 */
export const FilesAddResponseSchema: GenMessage<FilesAddResponse> =
  /*@__PURE__*/
  messageDesc(file_record, 33);

/**
 * @generated from message Records.FilesGetRequest
 */
export type FilesGetRequest = Message<"Records.FilesGetRequest"> & {
  /**
   * @generated from field: repeated bytes record_uids = 1;
   */
  recordUids: Uint8Array[];

  /**
   * @generated from field: bool for_thumbnails = 2;
   */
  forThumbnails: boolean;

  /**
   * @generated from field: string emergency_access_account_owner = 3;
   */
  emergencyAccessAccountOwner: string;
};

/**
 * Describes the message Records.FilesGetRequest.
 * Use `create(FilesGetRequestSchema)` to create a new message.
 */
export const FilesGetRequestSchema: GenMessage<FilesGetRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 34);

/**
 * @generated from message Records.FileGetStatus
 */
export type FileGetStatus = Message<"Records.FileGetStatus"> & {
  /**
   * @generated from field: bytes record_uid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: Records.FileGetResult status = 2;
   */
  status: FileGetResult;

  /**
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * @generated from field: int32 success_status_code = 4;
   */
  successStatusCode: number;

  /**
   * @generated from field: Records.RecordKeyType fileKeyType = 5;
   */
  fileKeyType: RecordKeyType;
};

/**
 * Describes the message Records.FileGetStatus.
 * Use `create(FileGetStatusSchema)` to create a new message.
 */
export const FileGetStatusSchema: GenMessage<FileGetStatus> =
  /*@__PURE__*/
  messageDesc(file_record, 35);

/**
 * @generated from message Records.FilesGetResponse
 */
export type FilesGetResponse = Message<"Records.FilesGetResponse"> & {
  /**
   * @generated from field: repeated Records.FileGetStatus files = 1;
   */
  files: FileGetStatus[];
};

/**
 * Describes the message Records.FilesGetResponse.
 * Use `create(FilesGetResponseSchema)` to create a new message.
 */
export const FilesGetResponseSchema: GenMessage<FilesGetResponse> =
  /*@__PURE__*/
  messageDesc(file_record, 36);

/**
 * @generated from message Records.ApplicationAddRequest
 */
export type ApplicationAddRequest = Message<"Records.ApplicationAddRequest"> & {
  /**
   * @generated from field: bytes app_uid = 1;
   */
  appUid: Uint8Array;

  /**
   * @generated from field: bytes record_key = 2;
   */
  recordKey: Uint8Array;

  /**
   * @generated from field: int64 client_modified_time = 3;
   */
  clientModifiedTime: bigint;

  /**
   * @generated from field: bytes data = 4;
   */
  data: Uint8Array;

  /**
   * @generated from field: Records.RecordAudit audit = 5;
   */
  audit?: RecordAudit;
};

/**
 * Describes the message Records.ApplicationAddRequest.
 * Use `create(ApplicationAddRequestSchema)` to create a new message.
 */
export const ApplicationAddRequestSchema: GenMessage<ApplicationAddRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 37);

/**
 * @generated from message Records.GetRecordDataWithAccessInfoRequest
 */
export type GetRecordDataWithAccessInfoRequest =
  Message<"Records.GetRecordDataWithAccessInfoRequest"> & {
    /**
     * @generated from field: int64 clientTime = 1;
     */
    clientTime: bigint;

    /**
     * @generated from field: repeated bytes recordUid = 2;
     */
    recordUid: Uint8Array[];

    /**
     * @generated from field: Records.RecordDetailsInclude recordDetailsInclude = 3;
     */
    recordDetailsInclude: RecordDetailsInclude;
  };

/**
 * Describes the message Records.GetRecordDataWithAccessInfoRequest.
 * Use `create(GetRecordDataWithAccessInfoRequestSchema)` to create a new message.
 */
export const GetRecordDataWithAccessInfoRequestSchema: GenMessage<GetRecordDataWithAccessInfoRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 38);

/**
 * @generated from message Records.UserPermission
 */
export type UserPermission = Message<"Records.UserPermission"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: bool owner = 2;
   */
  owner: boolean;

  /**
   * @generated from field: bool shareAdmin = 3;
   */
  shareAdmin: boolean;

  /**
   * @generated from field: bool sharable = 4;
   */
  sharable: boolean;

  /**
   * @generated from field: bool editable = 5;
   */
  editable: boolean;

  /**
   * @generated from field: bool awaitingApproval = 6;
   */
  awaitingApproval: boolean;

  /**
   * @generated from field: int64 expiration = 7;
   */
  expiration: bigint;

  /**
   * @generated from field: bytes accountUid = 8;
   */
  accountUid: Uint8Array;

  /**
   * @generated from field: Records.TimerNotificationType timerNotificationType = 9;
   */
  timerNotificationType: TimerNotificationType;

  /**
   * @generated from field: bool rotateOnExpiration = 10;
   */
  rotateOnExpiration: boolean;
};

/**
 * Describes the message Records.UserPermission.
 * Use `create(UserPermissionSchema)` to create a new message.
 */
export const UserPermissionSchema: GenMessage<UserPermission> =
  /*@__PURE__*/
  messageDesc(file_record, 39);

/**
 * @generated from message Records.SharedFolderPermission
 */
export type SharedFolderPermission = Message<"Records.SharedFolderPermission"> & {
  /**
   * @generated from field: bytes sharedFolderUid = 1;
   */
  sharedFolderUid: Uint8Array;

  /**
   * @generated from field: bool resharable = 2;
   */
  resharable: boolean;

  /**
   * @generated from field: bool editable = 3;
   */
  editable: boolean;

  /**
   * @generated from field: int64 revision = 4;
   */
  revision: bigint;

  /**
   * @generated from field: int64 expiration = 5;
   */
  expiration: bigint;

  /**
   * @generated from field: Records.TimerNotificationType timerNotificationType = 6;
   */
  timerNotificationType: TimerNotificationType;

  /**
   * @generated from field: bool rotateOnExpiration = 7;
   */
  rotateOnExpiration: boolean;
};

/**
 * Describes the message Records.SharedFolderPermission.
 * Use `create(SharedFolderPermissionSchema)` to create a new message.
 */
export const SharedFolderPermissionSchema: GenMessage<SharedFolderPermission> =
  /*@__PURE__*/
  messageDesc(file_record, 40);

/**
 * @generated from message Records.RecordData
 */
export type RecordData = Message<"Records.RecordData"> & {
  /**
   * @generated from field: int64 revision = 1;
   */
  revision: bigint;

  /**
   * @generated from field: int32 version = 2;
   */
  version: number;

  /**
   * @generated from field: bool shared = 3;
   */
  shared: boolean;

  /**
   * @generated from field: string encryptedRecordData = 4;
   */
  encryptedRecordData: string;

  /**
   * @generated from field: string encryptedExtraData = 5;
   */
  encryptedExtraData: string;

  /**
   * @generated from field: int64 clientModifiedTime = 6;
   */
  clientModifiedTime: bigint;

  /**
   * @generated from field: string nonSharedData = 7;
   */
  nonSharedData: string;

  /**
   * @generated from field: repeated Records.RecordData linkedRecordData = 8;
   */
  linkedRecordData: RecordData[];

  /**
   * @generated from field: repeated bytes fileId = 9;
   */
  fileId: Uint8Array[];

  /**
   * @generated from field: int64 fileSize = 10;
   */
  fileSize: bigint;

  /**
   * @generated from field: int64 thumbnailSize = 11;
   */
  thumbnailSize: bigint;

  /**
   * @generated from field: Records.RecordKeyType recordKeyType = 12;
   */
  recordKeyType: RecordKeyType;

  /**
   * @generated from field: bytes recordKey = 13;
   */
  recordKey: Uint8Array;

  /**
   * @generated from field: bytes recordUid = 14;
   */
  recordUid: Uint8Array;
};

/**
 * Describes the message Records.RecordData.
 * Use `create(RecordDataSchema)` to create a new message.
 */
export const RecordDataSchema: GenMessage<RecordData> = /*@__PURE__*/ messageDesc(file_record, 41);

/**
 * @generated from message Records.RecordDataWithAccessInfo
 */
export type RecordDataWithAccessInfo = Message<"Records.RecordDataWithAccessInfo"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: Records.RecordData recordData = 2;
   */
  recordData?: RecordData;

  /**
   * @generated from field: repeated Records.UserPermission userPermission = 3;
   */
  userPermission: UserPermission[];

  /**
   * @generated from field: repeated Records.SharedFolderPermission sharedFolderPermission = 4;
   */
  sharedFolderPermission: SharedFolderPermission[];
};

/**
 * Describes the message Records.RecordDataWithAccessInfo.
 * Use `create(RecordDataWithAccessInfoSchema)` to create a new message.
 */
export const RecordDataWithAccessInfoSchema: GenMessage<RecordDataWithAccessInfo> =
  /*@__PURE__*/
  messageDesc(file_record, 42);

/**
 * @generated from message Records.GetRecordDataWithAccessInfoResponse
 */
export type GetRecordDataWithAccessInfoResponse =
  Message<"Records.GetRecordDataWithAccessInfoResponse"> & {
    /**
     * @generated from field: repeated Records.RecordDataWithAccessInfo recordDataWithAccessInfo = 1;
     */
    recordDataWithAccessInfo: RecordDataWithAccessInfo[];

    /**
     * @generated from field: repeated bytes noPermissionRecordUid = 2;
     */
    noPermissionRecordUid: Uint8Array[];
  };

/**
 * Describes the message Records.GetRecordDataWithAccessInfoResponse.
 * Use `create(GetRecordDataWithAccessInfoResponseSchema)` to create a new message.
 */
export const GetRecordDataWithAccessInfoResponseSchema: GenMessage<GetRecordDataWithAccessInfoResponse> =
  /*@__PURE__*/
  messageDesc(file_record, 43);

/**
 * @generated from message Records.IsObjectShareAdmin
 */
export type IsObjectShareAdmin = Message<"Records.IsObjectShareAdmin"> & {
  /**
   * @generated from field: bytes uid = 1;
   */
  uid: Uint8Array;

  /**
   * @generated from field: bool isAdmin = 2;
   */
  isAdmin: boolean;

  /**
   * @generated from field: Records.CheckShareAdminObjectType objectType = 3;
   */
  objectType: CheckShareAdminObjectType;
};

/**
 * Describes the message Records.IsObjectShareAdmin.
 * Use `create(IsObjectShareAdminSchema)` to create a new message.
 */
export const IsObjectShareAdminSchema: GenMessage<IsObjectShareAdmin> =
  /*@__PURE__*/
  messageDesc(file_record, 44);

/**
 * @generated from message Records.AmIShareAdmin
 */
export type AmIShareAdmin = Message<"Records.AmIShareAdmin"> & {
  /**
   * @generated from field: repeated Records.IsObjectShareAdmin isObjectShareAdmin = 1;
   */
  isObjectShareAdmin: IsObjectShareAdmin[];
};

/**
 * Describes the message Records.AmIShareAdmin.
 * Use `create(AmIShareAdminSchema)` to create a new message.
 */
export const AmIShareAdminSchema: GenMessage<AmIShareAdmin> =
  /*@__PURE__*/
  messageDesc(file_record, 45);

/**
 * @generated from message Records.RecordShareUpdateRequest
 */
export type RecordShareUpdateRequest = Message<"Records.RecordShareUpdateRequest"> & {
  /**
   * @generated from field: repeated Records.SharedRecord addSharedRecord = 1;
   */
  addSharedRecord: SharedRecord[];

  /**
   * @generated from field: repeated Records.SharedRecord updateSharedRecord = 2;
   */
  updateSharedRecord: SharedRecord[];

  /**
   * @generated from field: repeated Records.SharedRecord removeSharedRecord = 3;
   */
  removeSharedRecord: SharedRecord[];

  /**
   * @generated from field: string pt = 4;
   */
  pt: string;
};

/**
 * Describes the message Records.RecordShareUpdateRequest.
 * Use `create(RecordShareUpdateRequestSchema)` to create a new message.
 */
export const RecordShareUpdateRequestSchema: GenMessage<RecordShareUpdateRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 46);

/**
 * @generated from message Records.SharedRecord
 */
export type SharedRecord = Message<"Records.SharedRecord"> & {
  /**
   * @generated from field: string toUsername = 1;
   */
  toUsername: string;

  /**
   * @generated from field: bytes recordUid = 2;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes recordKey = 3;
   */
  recordKey: Uint8Array;

  /**
   * @generated from field: bytes sharedFolderUid = 4;
   */
  sharedFolderUid: Uint8Array;

  /**
   * @generated from field: bytes teamUid = 5;
   */
  teamUid: Uint8Array;

  /**
   * @generated from field: bool editable = 6;
   */
  editable: boolean;

  /**
   * @generated from field: bool shareable = 7;
   */
  shareable: boolean;

  /**
   * @generated from field: bool transfer = 8;
   */
  transfer: boolean;

  /**
   * @generated from field: bool useEccKey = 9;
   */
  useEccKey: boolean;

  /**
   * @generated from field: bool removeVaultData = 10;
   */
  removeVaultData: boolean;

  /**
   * @generated from field: int64 expiration = 11;
   */
  expiration: bigint;

  /**
   * @generated from field: Records.TimerNotificationType timerNotificationType = 12;
   */
  timerNotificationType: TimerNotificationType;

  /**
   * @generated from field: bool rotateOnExpiration = 13;
   */
  rotateOnExpiration: boolean;
};

/**
 * Describes the message Records.SharedRecord.
 * Use `create(SharedRecordSchema)` to create a new message.
 */
export const SharedRecordSchema: GenMessage<SharedRecord> =
  /*@__PURE__*/
  messageDesc(file_record, 47);

/**
 * @generated from message Records.RecordShareUpdateResponse
 */
export type RecordShareUpdateResponse = Message<"Records.RecordShareUpdateResponse"> & {
  /**
   * @generated from field: repeated Records.SharedRecordStatus addSharedRecordStatus = 1;
   */
  addSharedRecordStatus: SharedRecordStatus[];

  /**
   * @generated from field: repeated Records.SharedRecordStatus updateSharedRecordStatus = 2;
   */
  updateSharedRecordStatus: SharedRecordStatus[];

  /**
   * @generated from field: repeated Records.SharedRecordStatus removeSharedRecordStatus = 3;
   */
  removeSharedRecordStatus: SharedRecordStatus[];
};

/**
 * Describes the message Records.RecordShareUpdateResponse.
 * Use `create(RecordShareUpdateResponseSchema)` to create a new message.
 */
export const RecordShareUpdateResponseSchema: GenMessage<RecordShareUpdateResponse> =
  /*@__PURE__*/
  messageDesc(file_record, 48);

/**
 * @generated from message Records.SharedRecordStatus
 */
export type SharedRecordStatus = Message<"Records.SharedRecordStatus"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: string username = 4;
   */
  username: string;
};

/**
 * Describes the message Records.SharedRecordStatus.
 * Use `create(SharedRecordStatusSchema)` to create a new message.
 */
export const SharedRecordStatusSchema: GenMessage<SharedRecordStatus> =
  /*@__PURE__*/
  messageDesc(file_record, 49);

/**
 * @generated from message Records.GetRecordPermissionsRequest
 */
export type GetRecordPermissionsRequest = Message<"Records.GetRecordPermissionsRequest"> & {
  /**
   * @generated from field: repeated bytes recordUids = 1;
   */
  recordUids: Uint8Array[];

  /**
   * @generated from field: bool isShareAdmin = 2;
   */
  isShareAdmin: boolean;
};

/**
 * Describes the message Records.GetRecordPermissionsRequest.
 * Use `create(GetRecordPermissionsRequestSchema)` to create a new message.
 */
export const GetRecordPermissionsRequestSchema: GenMessage<GetRecordPermissionsRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 50);

/**
 * @generated from message Records.GetRecordPermissionsResponse
 */
export type GetRecordPermissionsResponse = Message<"Records.GetRecordPermissionsResponse"> & {
  /**
   * @generated from field: repeated Records.RecordPermission recordPermissions = 1;
   */
  recordPermissions: RecordPermission[];
};

/**
 * Describes the message Records.GetRecordPermissionsResponse.
 * Use `create(GetRecordPermissionsResponseSchema)` to create a new message.
 */
export const GetRecordPermissionsResponseSchema: GenMessage<GetRecordPermissionsResponse> =
  /*@__PURE__*/
  messageDesc(file_record, 51);

/**
 * @generated from message Records.RecordPermission
 */
export type RecordPermission = Message<"Records.RecordPermission"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bool owner = 2;
   */
  owner: boolean;

  /**
   * @generated from field: bool canEdit = 3;
   */
  canEdit: boolean;

  /**
   * @generated from field: bool canShare = 4;
   */
  canShare: boolean;

  /**
   * @generated from field: bool canTransfer = 5;
   */
  canTransfer: boolean;
};

/**
 * Describes the message Records.RecordPermission.
 * Use `create(RecordPermissionSchema)` to create a new message.
 */
export const RecordPermissionSchema: GenMessage<RecordPermission> =
  /*@__PURE__*/
  messageDesc(file_record, 52);

/**
 * @generated from message Records.GetShareObjectsRequest
 */
export type GetShareObjectsRequest = Message<"Records.GetShareObjectsRequest"> & {
  /**
   * @generated from field: string startWith = 1;
   */
  startWith: string;

  /**
   * @generated from field: string contains = 2;
   */
  contains: string;

  /**
   * @generated from field: bool filtered = 3;
   */
  filtered: boolean;

  /**
   * @generated from field: bytes sharedFolderUid = 4;
   */
  sharedFolderUid: Uint8Array;
};

/**
 * Describes the message Records.GetShareObjectsRequest.
 * Use `create(GetShareObjectsRequestSchema)` to create a new message.
 */
export const GetShareObjectsRequestSchema: GenMessage<GetShareObjectsRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 53);

/**
 * @generated from message Records.GetShareObjectsResponse
 */
export type GetShareObjectsResponse = Message<"Records.GetShareObjectsResponse"> & {
  /**
   * @generated from field: repeated Records.ShareUser shareRelationships = 1;
   */
  shareRelationships: ShareUser[];

  /**
   * @generated from field: repeated Records.ShareUser shareFamilyUsers = 2;
   */
  shareFamilyUsers: ShareUser[];

  /**
   * @generated from field: repeated Records.ShareUser shareEnterpriseUsers = 3;
   */
  shareEnterpriseUsers: ShareUser[];

  /**
   * @generated from field: repeated Records.ShareTeam shareTeams = 4;
   */
  shareTeams: ShareTeam[];

  /**
   * @generated from field: repeated Records.ShareTeam shareMCTeams = 5;
   */
  shareMCTeams: ShareTeam[];

  /**
   * @generated from field: repeated Records.ShareUser shareMCEnterpriseUsers = 6;
   */
  shareMCEnterpriseUsers: ShareUser[];

  /**
   * @generated from field: repeated Records.ShareEnterprise shareEnterpriseNames = 7;
   */
  shareEnterpriseNames: ShareEnterprise[];
};

/**
 * Describes the message Records.GetShareObjectsResponse.
 * Use `create(GetShareObjectsResponseSchema)` to create a new message.
 */
export const GetShareObjectsResponseSchema: GenMessage<GetShareObjectsResponse> =
  /*@__PURE__*/
  messageDesc(file_record, 54);

/**
 * @generated from message Records.ShareUser
 */
export type ShareUser = Message<"Records.ShareUser"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string fullname = 2;
   */
  fullname: string;

  /**
   * @generated from field: int32 enterpriseId = 3;
   */
  enterpriseId: number;

  /**
   * @generated from field: Records.ShareStatus status = 4;
   */
  status: ShareStatus;

  /**
   * @generated from field: bool isShareAdmin = 5;
   */
  isShareAdmin: boolean;

  /**
   * @generated from field: bool isAdminOfSharedFolderOwner = 6;
   */
  isAdminOfSharedFolderOwner: boolean;
};

/**
 * Describes the message Records.ShareUser.
 * Use `create(ShareUserSchema)` to create a new message.
 */
export const ShareUserSchema: GenMessage<ShareUser> = /*@__PURE__*/ messageDesc(file_record, 55);

/**
 * @generated from message Records.ShareTeam
 */
export type ShareTeam = Message<"Records.ShareTeam"> & {
  /**
   * @generated from field: string teamname = 1;
   */
  teamname: string;

  /**
   * @generated from field: int32 enterpriseId = 2;
   */
  enterpriseId: number;

  /**
   * @generated from field: bytes teamUid = 3;
   */
  teamUid: Uint8Array;
};

/**
 * Describes the message Records.ShareTeam.
 * Use `create(ShareTeamSchema)` to create a new message.
 */
export const ShareTeamSchema: GenMessage<ShareTeam> = /*@__PURE__*/ messageDesc(file_record, 56);

/**
 * @generated from message Records.ShareEnterprise
 */
export type ShareEnterprise = Message<"Records.ShareEnterprise"> & {
  /**
   * @generated from field: string enterprisename = 1;
   */
  enterprisename: string;

  /**
   * @generated from field: int32 enterpriseId = 2;
   */
  enterpriseId: number;
};

/**
 * Describes the message Records.ShareEnterprise.
 * Use `create(ShareEnterpriseSchema)` to create a new message.
 */
export const ShareEnterpriseSchema: GenMessage<ShareEnterprise> =
  /*@__PURE__*/
  messageDesc(file_record, 57);

/**
 * @generated from message Records.RecordsOnwershipTransferRequest
 */
export type RecordsOnwershipTransferRequest = Message<"Records.RecordsOnwershipTransferRequest"> & {
  /**
   * @generated from field: repeated Records.TransferRecord transferRecords = 1;
   */
  transferRecords: TransferRecord[];
};

/**
 * Describes the message Records.RecordsOnwershipTransferRequest.
 * Use `create(RecordsOnwershipTransferRequestSchema)` to create a new message.
 */
export const RecordsOnwershipTransferRequestSchema: GenMessage<RecordsOnwershipTransferRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 58);

/**
 * @generated from message Records.TransferRecord
 */
export type TransferRecord = Message<"Records.TransferRecord"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: bytes recordUid = 2;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes recordKey = 3;
   */
  recordKey: Uint8Array;

  /**
   * @generated from field: bool useEccKey = 4;
   */
  useEccKey: boolean;
};

/**
 * Describes the message Records.TransferRecord.
 * Use `create(TransferRecordSchema)` to create a new message.
 */
export const TransferRecordSchema: GenMessage<TransferRecord> =
  /*@__PURE__*/
  messageDesc(file_record, 59);

/**
 * @generated from message Records.RecordsOnwershipTransferResponse
 */
export type RecordsOnwershipTransferResponse =
  Message<"Records.RecordsOnwershipTransferResponse"> & {
    /**
     * @generated from field: repeated Records.TransferRecordStatus transferRecordStatus = 1;
     */
    transferRecordStatus: TransferRecordStatus[];
  };

/**
 * Describes the message Records.RecordsOnwershipTransferResponse.
 * Use `create(RecordsOnwershipTransferResponseSchema)` to create a new message.
 */
export const RecordsOnwershipTransferResponseSchema: GenMessage<RecordsOnwershipTransferResponse> =
  /*@__PURE__*/
  messageDesc(file_record, 60);

/**
 * @generated from message Records.TransferRecordStatus
 */
export type TransferRecordStatus = Message<"Records.TransferRecordStatus"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: bytes recordUid = 2;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message Records.TransferRecordStatus.
 * Use `create(TransferRecordStatusSchema)` to create a new message.
 */
export const TransferRecordStatusSchema: GenMessage<TransferRecordStatus> =
  /*@__PURE__*/
  messageDesc(file_record, 61);

/**
 * @generated from message Records.RecordsUnshareRequest
 */
export type RecordsUnshareRequest = Message<"Records.RecordsUnshareRequest"> & {
  /**
   * @generated from field: repeated Records.RecordsUnshareFolder sharedFolders = 1;
   */
  sharedFolders: RecordsUnshareFolder[];

  /**
   * @generated from field: repeated Records.RecordsUnshareUser users = 2;
   */
  users: RecordsUnshareUser[];
};

/**
 * Describes the message Records.RecordsUnshareRequest.
 * Use `create(RecordsUnshareRequestSchema)` to create a new message.
 */
export const RecordsUnshareRequestSchema: GenMessage<RecordsUnshareRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 62);

/**
 * @generated from message Records.RecordsUnshareResponse
 */
export type RecordsUnshareResponse = Message<"Records.RecordsUnshareResponse"> & {
  /**
   * @generated from field: repeated Records.RecordsUnshareFolderStatus sharedFolders = 1;
   */
  sharedFolders: RecordsUnshareFolderStatus[];

  /**
   * @generated from field: repeated Records.RecordsUnshareUserStatus users = 2;
   */
  users: RecordsUnshareUserStatus[];
};

/**
 * Describes the message Records.RecordsUnshareResponse.
 * Use `create(RecordsUnshareResponseSchema)` to create a new message.
 */
export const RecordsUnshareResponseSchema: GenMessage<RecordsUnshareResponse> =
  /*@__PURE__*/
  messageDesc(file_record, 63);

/**
 * @generated from message Records.RecordsUnshareFolder
 */
export type RecordsUnshareFolder = Message<"Records.RecordsUnshareFolder"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes sharedFolderUid = 2;
   */
  sharedFolderUid: Uint8Array;
};

/**
 * Describes the message Records.RecordsUnshareFolder.
 * Use `create(RecordsUnshareFolderSchema)` to create a new message.
 */
export const RecordsUnshareFolderSchema: GenMessage<RecordsUnshareFolder> =
  /*@__PURE__*/
  messageDesc(file_record, 64);

/**
 * @generated from message Records.RecordsUnshareUser
 */
export type RecordsUnshareUser = Message<"Records.RecordsUnshareUser"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes accountUid = 2;
   */
  accountUid: Uint8Array;
};

/**
 * Describes the message Records.RecordsUnshareUser.
 * Use `create(RecordsUnshareUserSchema)` to create a new message.
 */
export const RecordsUnshareUserSchema: GenMessage<RecordsUnshareUser> =
  /*@__PURE__*/
  messageDesc(file_record, 65);

/**
 * @generated from message Records.RecordsUnshareFolderStatus
 */
export type RecordsUnshareFolderStatus = Message<"Records.RecordsUnshareFolderStatus"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes sharedFolderUid = 2;
   */
  sharedFolderUid: Uint8Array;
};

/**
 * Describes the message Records.RecordsUnshareFolderStatus.
 * Use `create(RecordsUnshareFolderStatusSchema)` to create a new message.
 */
export const RecordsUnshareFolderStatusSchema: GenMessage<RecordsUnshareFolderStatus> =
  /*@__PURE__*/
  messageDesc(file_record, 66);

/**
 * @generated from message Records.RecordsUnshareUserStatus
 */
export type RecordsUnshareUserStatus = Message<"Records.RecordsUnshareUserStatus"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes accountUid = 2;
   */
  accountUid: Uint8Array;
};

/**
 * Describes the message Records.RecordsUnshareUserStatus.
 * Use `create(RecordsUnshareUserStatusSchema)` to create a new message.
 */
export const RecordsUnshareUserStatusSchema: GenMessage<RecordsUnshareUserStatus> =
  /*@__PURE__*/
  messageDesc(file_record, 67);

/**
 * @generated from message Records.TimedAccessCallbackPayload
 */
export type TimedAccessCallbackPayload = Message<"Records.TimedAccessCallbackPayload"> & {
  /**
   * @generated from field: Records.TimeLimitedAccessType timeLimitedAccessType = 1;
   */
  timeLimitedAccessType: TimeLimitedAccessType;
};

/**
 * Describes the message Records.TimedAccessCallbackPayload.
 * Use `create(TimedAccessCallbackPayloadSchema)` to create a new message.
 */
export const TimedAccessCallbackPayloadSchema: GenMessage<TimedAccessCallbackPayload> =
  /*@__PURE__*/
  messageDesc(file_record, 68);

/**
 * @generated from message Records.TimeLimitedAccessRequest
 */
export type TimeLimitedAccessRequest = Message<"Records.TimeLimitedAccessRequest"> & {
  /**
   * @generated from field: repeated bytes accountUid = 1;
   */
  accountUid: Uint8Array[];

  /**
   * @generated from field: repeated bytes teamUid = 2;
   */
  teamUid: Uint8Array[];

  /**
   * @generated from field: repeated bytes recordUid = 3;
   */
  recordUid: Uint8Array[];

  /**
   * @generated from field: bytes sharedObjectUid = 4;
   */
  sharedObjectUid: Uint8Array;

  /**
   * @generated from field: Records.TimeLimitedAccessType timeLimitedAccessType = 5;
   */
  timeLimitedAccessType: TimeLimitedAccessType;

  /**
   * @generated from field: int64 expiration = 6;
   */
  expiration: bigint;

  /**
   * @generated from field: Records.TimerNotificationType timerNotificationType = 7;
   */
  timerNotificationType: TimerNotificationType;
};

/**
 * Describes the message Records.TimeLimitedAccessRequest.
 * Use `create(TimeLimitedAccessRequestSchema)` to create a new message.
 */
export const TimeLimitedAccessRequestSchema: GenMessage<TimeLimitedAccessRequest> =
  /*@__PURE__*/
  messageDesc(file_record, 69);

/**
 * @generated from message Records.TimeLimitedAccessStatus
 */
export type TimeLimitedAccessStatus = Message<"Records.TimeLimitedAccessStatus"> & {
  /**
   * @generated from field: bytes uid = 1;
   */
  uid: Uint8Array;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message Records.TimeLimitedAccessStatus.
 * Use `create(TimeLimitedAccessStatusSchema)` to create a new message.
 */
export const TimeLimitedAccessStatusSchema: GenMessage<TimeLimitedAccessStatus> =
  /*@__PURE__*/
  messageDesc(file_record, 70);

/**
 * @generated from message Records.TimeLimitedAccessResponse
 */
export type TimeLimitedAccessResponse = Message<"Records.TimeLimitedAccessResponse"> & {
  /**
   * @generated from field: int64 revision = 1;
   */
  revision: bigint;

  /**
   * @generated from field: repeated Records.TimeLimitedAccessStatus userAccessStatus = 2;
   */
  userAccessStatus: TimeLimitedAccessStatus[];

  /**
   * @generated from field: repeated Records.TimeLimitedAccessStatus teamAccessStatus = 3;
   */
  teamAccessStatus: TimeLimitedAccessStatus[];

  /**
   * @generated from field: repeated Records.TimeLimitedAccessStatus recordAccessStatus = 4;
   */
  recordAccessStatus: TimeLimitedAccessStatus[];
};

/**
 * Describes the message Records.TimeLimitedAccessResponse.
 * Use `create(TimeLimitedAccessResponseSchema)` to create a new message.
 */
export const TimeLimitedAccessResponseSchema: GenMessage<TimeLimitedAccessResponse> =
  /*@__PURE__*/
  messageDesc(file_record, 71);

/**
 * @generated from enum Records.RecordTypeScope
 */
export enum RecordTypeScope {
  /**
   * @generated from enum value: RT_STANDARD = 0;
   */
  RT_STANDARD = 0,

  /**
   * @generated from enum value: RT_USER = 1;
   */
  RT_USER = 1,

  /**
   * @generated from enum value: RT_ENTERPRISE = 2;
   */
  RT_ENTERPRISE = 2,

  /**
   * @generated from enum value: RT_PAM = 3;
   */
  RT_PAM = 3,

  /**
   * @generated from enum value: RT_PAM_CONFIGURATION = 4;
   */
  RT_PAM_CONFIGURATION = 4,
}

/**
 * Describes the enum Records.RecordTypeScope.
 */
export const RecordTypeScopeSchema: GenEnum<RecordTypeScope> =
  /*@__PURE__*/
  enumDesc(file_record, 0);

/**
 * @generated from enum Records.RecordKeyType
 */
export enum RecordKeyType {
  /**
   * @generated from enum value: NO_KEY = 0;
   */
  NO_KEY = 0,

  /**
   * @generated from enum value: ENCRYPTED_BY_DATA_KEY = 1;
   */
  ENCRYPTED_BY_DATA_KEY = 1,

  /**
   * @generated from enum value: ENCRYPTED_BY_PUBLIC_KEY = 2;
   */
  ENCRYPTED_BY_PUBLIC_KEY = 2,

  /**
   * @generated from enum value: ENCRYPTED_BY_DATA_KEY_GCM = 3;
   */
  ENCRYPTED_BY_DATA_KEY_GCM = 3,

  /**
   * @generated from enum value: ENCRYPTED_BY_PUBLIC_KEY_ECC = 4;
   */
  ENCRYPTED_BY_PUBLIC_KEY_ECC = 4,

  /**
   * @generated from enum value: ENCRYPTED_BY_ROOT_KEY_CBC = 5;
   */
  ENCRYPTED_BY_ROOT_KEY_CBC = 5,

  /**
   * @generated from enum value: ENCRYPTED_BY_ROOT_KEY_GCM = 6;
   */
  ENCRYPTED_BY_ROOT_KEY_GCM = 6,
}

/**
 * Describes the enum Records.RecordKeyType.
 */
export const RecordKeyTypeSchema: GenEnum<RecordKeyType> = /*@__PURE__*/ enumDesc(file_record, 1);

/**
 * @generated from enum Records.RecordFolderType
 */
export enum RecordFolderType {
  /**
   * @generated from enum value: user_folder = 0;
   */
  user_folder = 0,

  /**
   * @generated from enum value: shared_folder = 1;
   */
  shared_folder = 1,

  /**
   * @generated from enum value: shared_folder_folder = 2;
   */
  shared_folder_folder = 2,
}

/**
 * Describes the enum Records.RecordFolderType.
 */
export const RecordFolderTypeSchema: GenEnum<RecordFolderType> =
  /*@__PURE__*/
  enumDesc(file_record, 2);

/**
 * @generated from enum Records.RecordModifyResult
 */
export enum RecordModifyResult {
  /**
   * @generated from enum value: RS_SUCCESS = 0;
   */
  RS_SUCCESS = 0,

  /**
   * @generated from enum value: RS_OUT_OF_SYNC = 1;
   */
  RS_OUT_OF_SYNC = 1,

  /**
   * @generated from enum value: RS_ACCESS_DENIED = 2;
   */
  RS_ACCESS_DENIED = 2,

  /**
   * @generated from enum value: RS_SHARE_DENIED = 3;
   */
  RS_SHARE_DENIED = 3,

  /**
   * @generated from enum value: RS_RECORD_EXISTS = 4;
   */
  RS_RECORD_EXISTS = 4,

  /**
   * @generated from enum value: RS_OLD_RECORD_VERSION_TYPE = 5;
   */
  RS_OLD_RECORD_VERSION_TYPE = 5,

  /**
   * @generated from enum value: RS_NEW_RECORD_VERSION_TYPE = 6;
   */
  RS_NEW_RECORD_VERSION_TYPE = 6,

  /**
   * @generated from enum value: RS_FILES_NOT_MATCH = 7;
   */
  RS_FILES_NOT_MATCH = 7,

  /**
   * @generated from enum value: RS_RECORD_NOT_SHAREABLE = 8;
   */
  RS_RECORD_NOT_SHAREABLE = 8,

  /**
   * @generated from enum value: RS_ATTACHMENT_NOT_SHAREABLE = 9;
   */
  RS_ATTACHMENT_NOT_SHAREABLE = 9,

  /**
   * @generated from enum value: RS_FILE_LIMIT_REACHED = 10;
   */
  RS_FILE_LIMIT_REACHED = 10,

  /**
   * @generated from enum value: RS_SIZE_EXCEEDED_LIMIT = 11;
   */
  RS_SIZE_EXCEEDED_LIMIT = 11,

  /**
   * @generated from enum value: RS_ONLY_OWNER_CAN_MODIFY_SCRIPTS = 12;
   */
  RS_ONLY_OWNER_CAN_MODIFY_SCRIPTS = 12,
}

/**
 * Describes the enum Records.RecordModifyResult.
 */
export const RecordModifyResultSchema: GenEnum<RecordModifyResult> =
  /*@__PURE__*/
  enumDesc(file_record, 3);

/**
 * @generated from enum Records.FileAddResult
 */
export enum FileAddResult {
  /**
   * @generated from enum value: FA_SUCCESS = 0;
   */
  FA_SUCCESS = 0,

  /**
   * @generated from enum value: FA_ERROR = 1;
   */
  FA_ERROR = 1,
}

/**
 * Describes the enum Records.FileAddResult.
 */
export const FileAddResultSchema: GenEnum<FileAddResult> = /*@__PURE__*/ enumDesc(file_record, 4);

/**
 * @generated from enum Records.FileGetResult
 */
export enum FileGetResult {
  /**
   * @generated from enum value: FG_SUCCESS = 0;
   */
  FG_SUCCESS = 0,

  /**
   * @generated from enum value: FG_ERROR = 1;
   */
  FG_ERROR = 1,

  /**
   * @generated from enum value: FG_ACCESS_DENIED = 2;
   */
  FG_ACCESS_DENIED = 2,
}

/**
 * Describes the enum Records.FileGetResult.
 */
export const FileGetResultSchema: GenEnum<FileGetResult> = /*@__PURE__*/ enumDesc(file_record, 5);

/**
 * @generated from enum Records.RecordDetailsInclude
 */
export enum RecordDetailsInclude {
  /**
   * @generated from enum value: DATA_PLUS_SHARE = 0;
   */
  DATA_PLUS_SHARE = 0,

  /**
   * @generated from enum value: DATA_ONLY = 1;
   */
  DATA_ONLY = 1,

  /**
   * @generated from enum value: SHARE_ONLY = 2;
   */
  SHARE_ONLY = 2,
}

/**
 * Describes the enum Records.RecordDetailsInclude.
 */
export const RecordDetailsIncludeSchema: GenEnum<RecordDetailsInclude> =
  /*@__PURE__*/
  enumDesc(file_record, 6);

/**
 * @generated from enum Records.CheckShareAdminObjectType
 */
export enum CheckShareAdminObjectType {
  /**
   * @generated from enum value: CHECK_SA_INVALID_TYPE = 0;
   */
  CHECK_SA_INVALID_TYPE = 0,

  /**
   * @generated from enum value: CHECK_SA_ON_SF = 1;
   */
  CHECK_SA_ON_SF = 1,

  /**
   * @generated from enum value: CHECK_SA_ON_RECORD = 2;
   */
  CHECK_SA_ON_RECORD = 2,
}

/**
 * Describes the enum Records.CheckShareAdminObjectType.
 */
export const CheckShareAdminObjectTypeSchema: GenEnum<CheckShareAdminObjectType> =
  /*@__PURE__*/
  enumDesc(file_record, 7);

/**
 * @generated from enum Records.ShareStatus
 */
export enum ShareStatus {
  /**
   * @generated from enum value: ACTIVE = 0;
   */
  ACTIVE = 0,

  /**
   * @generated from enum value: BLOCK = 1;
   */
  BLOCK = 1,

  /**
   * @generated from enum value: INVITED = 2;
   */
  INVITED = 2,
}

/**
 * Describes the enum Records.ShareStatus.
 */
export const ShareStatusSchema: GenEnum<ShareStatus> = /*@__PURE__*/ enumDesc(file_record, 8);

/**
 * @generated from enum Records.RecordTransactionType
 */
export enum RecordTransactionType {
  /**
   * @generated from enum value: RTT_GENERAL = 0;
   */
  RTT_GENERAL = 0,

  /**
   * @generated from enum value: RTT_ROTATION = 1;
   */
  RTT_ROTATION = 1,
}

/**
 * Describes the enum Records.RecordTransactionType.
 */
export const RecordTransactionTypeSchema: GenEnum<RecordTransactionType> =
  /*@__PURE__*/
  enumDesc(file_record, 9);

/**
 * @generated from enum Records.TimeLimitedAccessType
 */
export enum TimeLimitedAccessType {
  /**
   * @generated from enum value: INVALID_TIME_LIMITED_ACCESS_TYPE = 0;
   */
  INVALID_TIME_LIMITED_ACCESS_TYPE = 0,

  /**
   * @generated from enum value: USER_ACCESS_TO_RECORD = 1;
   */
  USER_ACCESS_TO_RECORD = 1,

  /**
   * @generated from enum value: USER_OR_TEAM_ACCESS_TO_SHAREDFOLDER = 2;
   */
  USER_OR_TEAM_ACCESS_TO_SHAREDFOLDER = 2,

  /**
   * @generated from enum value: RECORD_ACCESS_TO_SHAREDFOLDER = 3;
   */
  RECORD_ACCESS_TO_SHAREDFOLDER = 3,

  /**
   * @generated from enum value: USER_ACCESS_TO_SHAREDFOLDER = 4;
   */
  USER_ACCESS_TO_SHAREDFOLDER = 4,

  /**
   * @generated from enum value: TEAM_ACCESS_TO_SHAREDFOLDER = 5;
   */
  TEAM_ACCESS_TO_SHAREDFOLDER = 5,
}

/**
 * Describes the enum Records.TimeLimitedAccessType.
 */
export const TimeLimitedAccessTypeSchema: GenEnum<TimeLimitedAccessType> =
  /*@__PURE__*/
  enumDesc(file_record, 10);

/**
 * @generated from enum Records.TimerNotificationType
 */
export enum TimerNotificationType {
  /**
   * @generated from enum value: NOTIFICATION_OFF = 0;
   */
  NOTIFICATION_OFF = 0,

  /**
   * @generated from enum value: NOTIFY_OWNER = 1;
   */
  NOTIFY_OWNER = 1,

  /**
   * @generated from enum value: NOTIFY_PRIVILEGED_USERS = 2;
   */
  NOTIFY_PRIVILEGED_USERS = 2,
}

/**
 * Describes the enum Records.TimerNotificationType.
 */
export const TimerNotificationTypeSchema: GenEnum<TimerNotificationType> =
  /*@__PURE__*/
  enumDesc(file_record, 11);
